import React from 'react';
import * as mobxReact from 'mobx-react';
import { OEToggle } from '../../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../../global/text/text';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { InfoPopover } from '../../../../../global/info-popover/info-popover';
import { MeetingExpiryDateVM } from './meeting-expiry-date.viewmodel';
import * as TEXTS from './meeting-expiry-date.texts';
import './meeting-expiry-date.scss';

interface IMeetingExpiryDateProps {
    vm: MeetingExpiryDateVM;
}

const MeetingExpiryDate = mobxReact.observer(({ vm }: IMeetingExpiryDateProps) => {
    const switchText = TEXTS.ENABLE_EXPIRY_TEXT.message + (vm.enabled ? ' enabled' : ' disabled');
    const onChangeDays = (e: React.ChangeEvent<HTMLInputElement>) => {
        vm.setDays(e.target.value);
    };

    return (
        <div className='meeting-expiry-date'>
            <div className='meeting-expiry-date__toggle-section m-bottom-25px flex meeting-toggle'>
                <div className='meeting-expiry-date__toggle'>
                    <OEToggle
                        isSelected={vm.enabled}
                        onClick={vm.toggleEnabled}
                    />
                    <Text {...TEXTS.ENABLE_EXPIRY_TEXT} message={switchText} />
                </div>
                <InfoPopover>
                    <div>
                        <Text {...TEXTS.EXPIRY_INFO_MESSAGE_TEXT} />
                    </div>
                </InfoPopover>
            </div>

            {vm.enabled && (
                <div className='m-bottom-25px'>
                    <FormField className='meeting-form__form-field'>
                        <div className='meeting-expiry-date__input-wrapper'>
                            <span className='meeting-expiry-date__input-label'>
                                <Text {...TEXTS.EXPIRY_DAYS_PREFIX_TEXT} />
                            </span>
                            <input
                                className='oe-form-field__control meeting-expiry-date__input'
                                type='number'
                                min='1'
                                max='999'
                                value={vm.daysValue || ''}
                                onChange={onChangeDays}
                                placeholder='XXX'
                            />
                            <span className='meeting-expiry-date__input-suffix'>
                                <Text {...TEXTS.EXPIRY_DAYS_SUFFIX_TEXT} />
                            </span>
                        </div>

                        {vm.getValidationError() && (
                            <span className='oe-form-field__error'>
                                {vm.getValidationError()}
                            </span>
                        )}

                        {!vm.getValidationError() && vm.displayText && (
                            <div className='oe-form-field__info'>
                                {vm.displayText}
                            </div>
                        )}
                    </FormField>
                </div>
            )}
        </div>
    );
});

export { MeetingExpiryDate };
